import { render, staticRenderFns } from "./BG.vue?vue&type=template&id=12b8da77&"
import script from "./BG.js?vue&type=script&lang=js&"
export * from "./BG.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports